module.exports = __webpack_public_path__ + "static/media/slash.023471be.svg";